import { atom } from 'jotai';

export const $ToastAtom = atom({
  time: 0,
  content: '',
});
